// Copyright (c) 2023 WiseTime. All rights reserved.

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file wisetime/user/assistant/v4/preferences.proto (package wisetime.user.assistant.v4, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { TranslateLanguage } from "./assistant_pb";
import { file_wisetime_user_assistant_v4_assistant } from "./assistant_pb";
import type { EmptySchema } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file wisetime/user/assistant/v4/preferences.proto.
 */
export const file_wisetime_user_assistant_v4_preferences: GenFile = /*@__PURE__*/
  fileDesc("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", [file_wisetime_user_assistant_v4_assistant, file_google_protobuf_empty]);

/**
 * @generated from message wisetime.user.assistant.v4.SetNarratePreferencesRequest
 */
export type SetNarratePreferencesRequest = Message<"wisetime.user.assistant.v4.SetNarratePreferencesRequest"> & {
  /**
   * @generated from field: wisetime.user.assistant.v4.NarratePreferences preferences = 1;
   */
  preferences?: NarratePreferences;

  /**
   * training narratives used by the user for this preferences.
   *
   * @generated from field: repeated wisetime.user.assistant.v4.TrainingNarrative training_narratives = 5;
   */
  trainingNarratives: TrainingNarrative[];
};

/**
 * Describes the message wisetime.user.assistant.v4.SetNarratePreferencesRequest.
 * Use `create(SetNarratePreferencesRequestSchema)` to create a new message.
 */
export const SetNarratePreferencesRequestSchema: GenMessage<SetNarratePreferencesRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_assistant_v4_preferences, 0);

/**
 * @generated from message wisetime.user.assistant.v4.NarratePreferences
 */
export type NarratePreferences = Message<"wisetime.user.assistant.v4.NarratePreferences"> & {
  /**
   * @generated from field: wisetime.user.assistant.v4.NarrateLength narrate_length = 1;
   */
  narrateLength: NarrateLength;

  /**
   * @generated from field: wisetime.user.assistant.v4.Tense tense = 2;
   */
  tense: Tense;

  /**
   * if not set, language will be detected automatically
   *
   * @generated from field: optional wisetime.user.assistant.v4.TranslateLanguage language = 3;
   */
  language?: TranslateLanguage;

  /**
   * @generated from field: optional string custom_prompt = 4;
   */
  customPrompt?: string;
};

/**
 * Describes the message wisetime.user.assistant.v4.NarratePreferences.
 * Use `create(NarratePreferencesSchema)` to create a new message.
 */
export const NarratePreferencesSchema: GenMessage<NarratePreferences> = /*@__PURE__*/
  messageDesc(file_wisetime_user_assistant_v4_preferences, 1);

/**
 * @generated from message wisetime.user.assistant.v4.ListTrainingGroupsRequest
 */
export type ListTrainingGroupsRequest = Message<"wisetime.user.assistant.v4.ListTrainingGroupsRequest"> & {
  /**
   * number of training groups
   *
   * @generated from field: uint32 count = 1;
   */
  count: number;

  /**
   * @generated from field: repeated string exclude_training_group_ids = 2;
   */
  excludeTrainingGroupIds: string[];
};

/**
 * Describes the message wisetime.user.assistant.v4.ListTrainingGroupsRequest.
 * Use `create(ListTrainingGroupsRequestSchema)` to create a new message.
 */
export const ListTrainingGroupsRequestSchema: GenMessage<ListTrainingGroupsRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_assistant_v4_preferences, 2);

/**
 * @generated from message wisetime.user.assistant.v4.ListTrainingGroupsResponse
 */
export type ListTrainingGroupsResponse = Message<"wisetime.user.assistant.v4.ListTrainingGroupsResponse"> & {
  /**
   * may be less then requested count when no more training group can be created
   *
   * @generated from field: repeated wisetime.user.assistant.v4.TrainingGroup training_groups = 1;
   */
  trainingGroups: TrainingGroup[];
};

/**
 * Describes the message wisetime.user.assistant.v4.ListTrainingGroupsResponse.
 * Use `create(ListTrainingGroupsResponseSchema)` to create a new message.
 */
export const ListTrainingGroupsResponseSchema: GenMessage<ListTrainingGroupsResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_user_assistant_v4_preferences, 3);

/**
 * @generated from message wisetime.user.assistant.v4.TrainingGroup
 */
export type TrainingGroup = Message<"wisetime.user.assistant.v4.TrainingGroup"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: repeated wisetime.user.assistant.v4.TrainingRow rows = 2;
   */
  rows: TrainingRow[];
};

/**
 * Describes the message wisetime.user.assistant.v4.TrainingGroup.
 * Use `create(TrainingGroupSchema)` to create a new message.
 */
export const TrainingGroupSchema: GenMessage<TrainingGroup> = /*@__PURE__*/
  messageDesc(file_wisetime_user_assistant_v4_preferences, 4);

/**
 * @generated from message wisetime.user.assistant.v4.TrainingRow
 */
export type TrainingRow = Message<"wisetime.user.assistant.v4.TrainingRow"> & {
  /**
   * @generated from field: string app_name = 1;
   */
  appName: string;

  /**
   * @generated from field: string window_title = 2;
   */
  windowTitle: string;

  /**
   * @generated from field: string icon_url = 3;
   */
  iconUrl: string;
};

/**
 * Describes the message wisetime.user.assistant.v4.TrainingRow.
 * Use `create(TrainingRowSchema)` to create a new message.
 */
export const TrainingRowSchema: GenMessage<TrainingRow> = /*@__PURE__*/
  messageDesc(file_wisetime_user_assistant_v4_preferences, 5);

/**
 * @generated from message wisetime.user.assistant.v4.GetTrainingNarrativeRequest
 */
export type GetTrainingNarrativeRequest = Message<"wisetime.user.assistant.v4.GetTrainingNarrativeRequest"> & {
  /**
   * @generated from field: wisetime.user.assistant.v4.NarratePreferences preferences = 1;
   */
  preferences?: NarratePreferences;

  /**
   * @generated from field: wisetime.user.assistant.v4.TrainingGroup training_group = 2;
   */
  trainingGroup?: TrainingGroup;
};

/**
 * Describes the message wisetime.user.assistant.v4.GetTrainingNarrativeRequest.
 * Use `create(GetTrainingNarrativeRequestSchema)` to create a new message.
 */
export const GetTrainingNarrativeRequestSchema: GenMessage<GetTrainingNarrativeRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_assistant_v4_preferences, 6);

/**
 * @generated from message wisetime.user.assistant.v4.TrainingNarrative
 */
export type TrainingNarrative = Message<"wisetime.user.assistant.v4.TrainingNarrative"> & {
  /**
   * @generated from field: wisetime.user.assistant.v4.TrainingGroup training_group = 1;
   */
  trainingGroup?: TrainingGroup;

  /**
   * @generated from field: string narrative = 2;
   */
  narrative: string;
};

/**
 * Describes the message wisetime.user.assistant.v4.TrainingNarrative.
 * Use `create(TrainingNarrativeSchema)` to create a new message.
 */
export const TrainingNarrativeSchema: GenMessage<TrainingNarrative> = /*@__PURE__*/
  messageDesc(file_wisetime_user_assistant_v4_preferences, 7);

/**
 * @generated from enum wisetime.user.assistant.v4.NarrateLength
 */
export enum NarrateLength {
  /**
   * @generated from enum value: NARRATE_LENGTH_UNSPECIFIED = 0;
   */
  NARRATE_LENGTH_UNSPECIFIED = 0,

  /**
   * @generated from enum value: SHORT = 1;
   */
  SHORT = 1,

  /**
   * @generated from enum value: STANDARD = 2;
   */
  STANDARD = 2,

  /**
   * @generated from enum value: LONG = 3;
   */
  LONG = 3,
}

/**
 * Describes the enum wisetime.user.assistant.v4.NarrateLength.
 */
export const NarrateLengthSchema: GenEnum<NarrateLength> = /*@__PURE__*/
  enumDesc(file_wisetime_user_assistant_v4_preferences, 0);

/**
 * @generated from enum wisetime.user.assistant.v4.Tense
 */
export enum Tense {
  /**
   * @generated from enum value: TENSE_UNSPECIFIED = 0;
   */
  TENSE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: PAST = 1;
   */
  PAST = 1,

  /**
   * @generated from enum value: PRESENT = 2;
   */
  PRESENT = 2,
}

/**
 * Describes the enum wisetime.user.assistant.v4.Tense.
 */
export const TenseSchema: GenEnum<Tense> = /*@__PURE__*/
  enumDesc(file_wisetime_user_assistant_v4_preferences, 1);

/**
 * @generated from service wisetime.user.assistant.v4.NarratePreferencesService
 */
export const NarratePreferencesService: GenService<{
  /**
   * @generated from rpc wisetime.user.assistant.v4.NarratePreferencesService.GetDefaultNarratePreferences
   */
  getDefaultNarratePreferences: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof NarratePreferencesSchema;
  },
  /**
   * Get narrative preferences for current user.
   * If user don't have personal preferences, default preferences will be returned.
   *
   * @generated from rpc wisetime.user.assistant.v4.NarratePreferencesService.GetNarratePreferences
   */
  getNarratePreferences: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof NarratePreferencesSchema;
  },
  /**
   * @generated from rpc wisetime.user.assistant.v4.NarratePreferencesService.SetNarratePreferences
   */
  setNarratePreferences: {
    methodKind: "unary";
    input: typeof SetNarratePreferencesRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc wisetime.user.assistant.v4.NarratePreferencesService.ListTrainingGroups
   */
  listTrainingGroups: {
    methodKind: "unary";
    input: typeof ListTrainingGroupsRequestSchema;
    output: typeof ListTrainingGroupsResponseSchema;
  },
  /**
   * @generated from rpc wisetime.user.assistant.v4.NarratePreferencesService.GetTrainingNarrative
   */
  getTrainingNarrative: {
    methodKind: "unary";
    input: typeof GetTrainingNarrativeRequestSchema;
    output: typeof TrainingNarrativeSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_wisetime_user_assistant_v4_preferences, 0);

